export const STATE_CODES = [
  ["AL", "Alabama"],
  ["AK", "Alaska"],
  ["AS", "American Samoa"],
  ["AZ", "Arizona"],
  ["AR", "Arkansas"],
  ["CA", "California"],
  ["CO", "Colorado"],
  ["CT", "Connecticut"],
  ["DE", "Delaware"],
  ["DC", "District Of Columbia"],
  ["FM", "Federated States Of Micronesia"],
  ["FL", "Florida"],
  ["GA", "Georgia"],
  ["GU", "Guam"],
  ["HI", "Hawaii"],
  ["ID", "Idaho"],
  ["IL", "Illinois"],
  ["IN", "Indiana"],
  ["IA", "Iowa"],
  ["KS", "Kansas"],
  ["KY", "Kentucky"],
  ["LA", "Louisiana"],
  ["ME", "Maine"],
  ["MH", "Marshall Islands"],
  ["MD", "Maryland"],
  ["MA", "Massachusetts"],
  ["MI", "Michigan"],
  ["MN", "Minnesota"],
  ["MS", "Mississippi"],
  ["MO", "Missouri"],
  ["MT", "Montana"],
  ["NE", "Nebraska"],
  ["NV", "Nevada"],
  ["NH", "New Hampshire"],
  ["NJ", "New Jersey"],
  ["NM", "New Mexico"],
  ["NY", "New York"],
  ["NC", "North Carolina"],
  ["ND", "North Dakota"],
  ["MP", "Northern Mariana Islands"],
  ["OH", "Ohio"],
  ["OK", "Oklahoma"],
  ["OR", "Oregon"],
  ["PW", "Palau"],
  ["PA", "Pennsylvania"],
  ["PR", "Puerto Rico"],
  ["RI", "Rhode Island"],
  ["SC", "South Carolina"],
  ["SD", "South Dakota"],
  ["TN", "Tennessee"],
  ["TX", "Texas"],
  ["UT", "Utah"],
  ["VT", "Vermont"],
  ["VI", "Virgin Islands"],
  ["VA", "Virginia"],
  ["WA", "Washington"],
  ["WV", "West Virginia"],
  ["WI", "Wisconsin"],
  ["WY", "Wyoming"],
];

export const COUNTRY_NAME_TO_CODE = {
  afghanistan: "af",
  "åland islands": "ax",
  "aland islands": "ax",
  albania: "al",
  algeria: "dz",
  "american samoa": "as",
  andorra: "ad",
  angola: "ao",
  anguilla: "ai",
  antarctica: "aq",
  "antigua and barbuda": "ag",
  argentina: "ar",
  armenia: "am",
  aruba: "aw",
  australia: "au",
  austria: "at",
  azerbaijan: "az",
  bahamas: "bs",
  bahrain: "bh",
  bangladesh: "bd",
  barbados: "bb",
  belarus: "by",
  belgium: "be",
  belize: "bz",
  benin: "bj",
  bermuda: "bm",
  bhutan: "bt",
  "bolivia, plurinational state of": "bo",
  bolivia: "bo",
  "bonaire, sint eustatius and saba": "bq",
  "bosnia and herzegovina": "ba",
  botswana: "bw",
  "bouvet island": "bv",
  brazil: "br",
  "british indian ocean territory": "io",
  "brunei darussalam": "bn",
  bulgaria: "bg",
  "burkina faso": "bf",
  burundi: "bi",
  cambodia: "kh",
  cameroon: "cm",
  canada: "ca",
  "cape verde": "cv",
  "cayman islands": "ky",
  "central african republic": "cf",
  chad: "td",
  chile: "cl",
  china: "cn",
  "christmas island": "cx",
  "cocos (keeling) islands": "cc",
  colombia: "co",
  comoros: "km",
  congo: "cg",
  "congo (brazzaville)": "cg",
  "congo, the republic of the": "cg",
  "congo, republic of the": "cg",
  "the republic of the congo": "cg",
  "republic of the congo": "cg",
  "congo, the democratic republic of the": "cd",
  "congo, democratic republic of the": "cd",
  "the democratic republic of the congo": "cd",
  "democratic republic of the congo": "cd",
  "congo (kinshasa)": "cd",
  "cook islands": "ck",
  "costa rica": "cr",
  "côte d'ivoire": "ci",
  croatia: "hr",
  cuba: "cu",
  curaçao: "cw",
  cyprus: "cy",
  "czech republic": "cz",
  czechia: "cz",
  denmark: "dk",
  djibouti: "dj",
  dominica: "dm",
  "dominican republic": "do",
  ecuador: "ec",
  egypt: "eg",
  "el salvador": "sv",
  "equatorial guinea": "gq",
  eritrea: "er",
  estonia: "ee",
  ethiopia: "et",
  "falkland islands (malvinas)": "fk",
  "falkland islands (islas malvinas)": "fk",
  "falkland islands": "fk",
  "faroe islands": "fo",
  "fårö islands": "fo",
  fårö: "fo",
  fiji: "fj",
  finland: "fi",
  france: "fr",
  "french guiana": "gf",
  "french polynesia": "pf",
  "french southern territories": "tf",
  gabon: "ga",
  gambia: "gm",
  georgia: "ge",
  germany: "de",
  ghana: "gh",
  gibraltar: "gi",
  greece: "gr",
  greenland: "gl",
  grenada: "gd",
  guadeloupe: "gp",
  guam: "gu",
  guatemala: "gt",
  guernsey: "gg",
  guinea: "gn",
  "guinea-bissau": "gw",
  guyana: "gy",
  haiti: "ht",
  "heard island and mcdonald islands": "hm",
  "holy see (vatican city state)": "va",
  honduras: "hn",
  "hong kong": "hk",
  hungary: "hu",
  iceland: "is",
  india: "in",
  indonesia: "id",
  "iran, islamic republic of": "ir",
  "islamic republic of iran": "ir",
  iran: "ir",
  iraq: "iq",
  "iraq, republic of": "iq",
  "republic of iraq": "iq",
  ireland: "ie",
  "isle of man": "im",
  israel: "il",
  italy: "it",
  jamaica: "jm",
  japan: "jp",
  jersey: "je",
  jordan: "jo",
  kazakhstan: "kz",
  kenya: "ke",
  kiribati: "ki",
  "korea, democratic people's republic of": "kp",
  "democratic people's republic of korea": "kp",
  "north korea": "kp",
  "korea, republic of": "kr",
  "republic of korea": "kr",
  "south korea": "kr",
  kosovo: "xk",
  "kosovo, republic of": "xk",
  "kosovo, the republic of": "xk",
  "the republic of kosovo": "xk",
  kuwait: "kw",
  kyrgyzstan: "kg",
  "lao people's democratic republic": "la",
  laos: "la",
  latvia: "lv",
  lebanon: "lb",
  lesotho: "ls",
  liberia: "lr",
  libya: "ly",
  liechtenstein: "li",
  lithuania: "lt",
  luxembourg: "lu",
  macao: "mo",
  "macedonia, the former yugoslav republic of": "mk",
  "macedonia, former yugoslav republic of": "mk",
  "north macedonia": "mk",
  macedonia: "mk",
  madagascar: "mg",
  malawi: "mw",
  malaysia: "my",
  maldives: "mv",
  mali: "ml",
  malta: "mt",
  "marshall islands": "mh",
  martinique: "mq",
  mauritania: "mr",
  mauritius: "mu",
  mayotte: "yt",
  mexico: "mx",
  "micronesia, federated states of": "fm",
  "moldova, republic of": "md",
  "republic of moldova": "md",
  moldova: "md",
  monaco: "mc",
  mongolia: "mn",
  montenegro: "me",
  montserrat: "ms",
  morocco: "ma",
  mozambique: "mz",
  myanmar: "mm",
  namibia: "na",
  nauru: "nr",
  nepal: "np",
  netherlands: "nl",
  "new caledonia": "nc",
  "new zealand": "nz",
  nicaragua: "ni",
  niger: "ne",
  nigeria: "ng",
  niue: "nu",
  "norfolk island": "nf",
  "northern mariana islands": "mp",
  norway: "no",
  oman: "om",
  pakistan: "pk",
  palau: "pw",
  "palestine, state of": "ps",
  panama: "pa",
  "papua new guinea": "pg",
  paraguay: "py",
  peru: "pe",
  philippines: "ph",
  pitcairn: "pn",
  poland: "pl",
  portugal: "pt",
  "puerto rico": "pr",
  qatar: "qa",
  réunion: "re",
  reunion: "re",
  romania: "ro",
  "russian federation": "ru",
  russia: "ru",
  rwanda: "rw",
  "saint barthélemy": "bl",
  "saint helena, ascension and tristan da cunha": "sh",
  "saint kitts and nevis": "kn",
  "saint lucia": "lc",
  "saint martin (french part)": "mf",
  "saint pierre and miquelon": "pm",
  "saint vincent and the grenadines": "vc",
  samoa: "ws",
  "san marino": "sm",
  "sao tome and principe": "st",
  "saudi arabia": "sa",
  senegal: "sn",
  serbia: "rs",
  seychelles: "sc",
  "sierra leone": "sl",
  singapore: "sg",
  "sint maarten (dutch part)": "sx",
  slovakia: "sk",
  slovenia: "si",
  "solomon islands": "sb",
  somalia: "so",
  "south africa": "za",
  "south georgia and the south sandwich islands": "gs",
  "south sudan": "ss",
  spain: "es",
  "sri lanka": "lk",
  sudan: "sd",
  suriname: "sr",
  "svalbard and jan mayen": "sj",
  svalbard: "sj",
  swaziland: "sz",
  sweden: "se",
  switzerland: "ch",
  "syrian arab republic": "sy",
  syria: "sy",
  "taiwan, province of china": "tw",
  taiwan: "tw",
  tajikistan: "tj",
  "tanzania, united republic of": "tz",
  tanzania: "tz",
  thailand: "th",
  "timor-leste": "tl",
  "timor leste": "tl",
  "east timor": "tl",
  togo: "tg",
  tokelau: "tk",
  tonga: "to",
  "trinidad and tobago": "tt",
  tunisia: "tn",
  turkey: "tr",
  turkmenistan: "tm",
  "turks and caicos islands": "tc",
  tuvalu: "tv",
  uganda: "ug",
  ukraine: "ua",
  "united arab emirates": "ae",
  "united kingdom": "gb",
  "united states": "us",
  "united states minor outlying islands": "um",
  uruguay: "uy",
  uzbekistan: "uz",
  vanuatu: "vu",
  "venezuela, bolivarian republic of": "ve",
  venezuela: "ve",
  "viet nam": "vn",
  vietnam: "vn",
  "Việt Nam": "vn",
  "virgin islands, british": "vg",
  "virgin islands, u.s.": "vi",
  "wallis and futuna": "wf",
  "western sahara": "eh",
  yemen: "ye",
  zambia: "zm",
  zimbabwe: "zw",
};
